import budgetSubject from "./budgetSubject"
import file from "./file"
import budgetStandard from "./budgetStandard"
import baseResource from "./baseResource"
import subject from "./subject"
import socialEconomy from "./socialEconomy"
import nationalEconomy from "./nationalEconomy"
import magazineSource from "./magazineSource"
import magazine from "./magazine"
import paperLevel from "./paperLevel"


export default {
    budgetSubject,
    file,
    budgetStandard,
    baseResource,
    subject,
    socialEconomy,
    nationalEconomy,
    magazineSource,
    magazine,
    paperLevel

}